var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.524,
    height: 80.525,
    viewBox: "0 0 80.524 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M267.246-30.237A39.263,39.263,0,0,1,227.984,9.025a39.263,39.263,0,0,1-39.262-39.262A39.263,39.263,0,0,1,227.984-69.5a39.263,39.263,0,0,1,39.262,39.263",
    transform: "translate(-188.722 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M217.419-43.833a2.535,2.535,0,0,0,2.535,2.535,2.535,2.535,0,0,0,2.534-2.535,2.535,2.535,0,0,0-2.534-2.534,2.535,2.535,0,0,0-2.535,2.534",
    transform: "translate(-217.419 46.367)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M218.715-44.033A1.037,1.037,0,0,0,219.753-43a1.036,1.036,0,0,0,1.035-1.037,1.035,1.035,0,0,0-1.035-1.035,1.037,1.037,0,0,0-1.038,1.035",
    transform: "translate(-218.715 45.069)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M231.028-43.875a2.533,2.533,0,0,0,2.534,2.533,2.534,2.534,0,0,0,2.535-2.533,2.534,2.534,0,0,0-2.535-2.534,2.533,2.533,0,0,0-2.534,2.534",
    transform: "translate(-231.028 46.409)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M232.325-44.075a1.036,1.036,0,0,0,1.037,1.035,1.036,1.036,0,0,0,1.038-1.035,1.037,1.037,0,0,0-1.038-1.037,1.037,1.037,0,0,0-1.037,1.037",
    transform: "translate(-232.325 45.112)",
    fill: "#00142e",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_4",
    "data-name": "Pain 4",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775",
    transform: "translate(0)",
    clipPath: "url(#clip-path-painscore4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M187.722-70.5h80.833V10.334H187.722Z",
    transform: "translate(-188.876 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    d: "M78.524,39.263A39.262,39.262,0,1,1,39.262,0,39.263,39.263,0,0,1,78.524,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(29.507 22.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M0,6.3A6.3,6.3,0,1,0,6.3,0,6.3,6.3,0,0,0,0,6.3Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(33.125 26.703)",
    clipPath: "url(#clip-path-2-painscore4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M216.419-47.367H223.8v7.377h-7.377Z",
    transform: "translate(-217.573 46.212)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(34.622 28.202)",
    clipPath: "url(#clip-path-3-painscore4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M217.715-46.069H222.1v4.381h-4.382Z",
    transform: "translate(-218.87 44.914)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796",
    transform: "translate(44.76 22.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M0,6.028A6.028,6.028,0,1,0,6.028,0,6.027,6.027,0,0,0,0,6.028Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    transform: "translate(48.836 26.655)",
    clipPath: "url(#clip-path-4-painscore4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M230.028-47.409h7.377v7.375h-7.377Z",
    transform: "translate(-231.183 46.254)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800",
    transform: "translate(50.333 28.152)",
    clipPath: "url(#clip-path-5-painscore4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M231.325-46.112h4.383v4.381h-4.383Z",
    transform: "translate(-232.48 44.957)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830",
    transform: "translate(35.273 40.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M.475,0S-1.231,3.232,1.821,3.232a12.681,12.681,0,0,1,4.758.718,3.64,3.64,0,0,0,3.053-.27,9.966,9.966,0,0,1,3.321-.987c1.347-.09,0-2.693,0-2.693",
    transform: "translate(0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831",
    transform: "translate(23.27 53.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M0,0A53.01,53.01,0,0,1,7.99,1.347c3.052.9,6.015.628,11.581.359a144.353,144.353,0,0,1,15.89.449",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832",
    transform: "translate(22.822 13.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M0,3.94S6.105-2.974,15.8,1.516",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833",
    transform: "translate(49.575 15.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M0,1.5s6.733-3.95,11.041.987",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore4);
export default __webpack_public_path__ + "static/media/pain_score_4.4c75fe33.svg";
export { ForwardRef as ReactComponent };